export function setup(conf) {
	config = Object.assign(config, conf);
}

var config = {};
export default config;


// WEBPACK FOOTER //
// ./src/modules/utils/config.js